import React from 'react';
import '../style/css/invites.css'
import TopNavbar from "./TopNavbar";
import TableForEdit from "./TableForEdit";
import '../style/css/tableforedit.css'


function InvitesPage() {

    return (
        <>
            <div className={'main-info-container'}>
                <div className={'top-invites-container flex'}>
                    <div className={'invites-header-container flex'}>
                        <div className={'sum-of-invites'}>83P</div>
                        <h2>מוזמנים</h2>
                        <div className={'search-fillter-container flex'}>
                            <button>סנן לפי שעה</button>
                            <input type={"search"} placeholder={'חיפוש...'}/>
                        </div>
                    </div>
                    <TableForEdit/>
                </div>
            </div>

        </>
    );
}

export default InvitesPage;